import React, { useState } from 'react';
import { Download, FileSpreadsheet, FileText, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function ExportButton() {
  const [isOpen, setIsOpen] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const handleExport = (type: string) => {
    setIsExporting(true);
    setIsOpen(false);
    // Simulate export delay
    setTimeout(() => {
      setIsExporting(false);
      // Ideally show a toast here
      console.log(`Exported ${type}`);
    }, 1500);
  };
  return <div className="relative" data-id="element-202">
      <button onClick={() => setIsOpen(!isOpen)} disabled={isExporting} className="flex items-center space-x-2 px-4 py-2 bg-white border border-slate-200 rounded-lg text-sm font-medium text-slate-600 hover:bg-slate-50 hover:border-slate-300 transition-colors disabled:opacity-70" data-id="element-203">
        {isExporting ? <div className="h-4 w-4 border-2 border-slate-300 border-t-slate-600 rounded-full animate-spin" data-id="element-204" /> : <Download className="h-4 w-4" data-id="element-205" />}
        <span data-id="element-206">{isExporting ? 'Exportando...' : 'Exportar'}</span>
        <ChevronDown className={`h-3 w-3 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-207" />
      </button>

      <AnimatePresence data-id="element-208">
        {isOpen && <>
            <div className="fixed inset-0 z-30" onClick={() => setIsOpen(false)} data-id="element-209" />
            <motion.div initial={{
          opacity: 0,
          y: 10,
          scale: 0.95
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 10,
          scale: 0.95
        }} className="absolute top-full right-0 mt-2 w-56 bg-white rounded-xl shadow-xl border border-slate-200 z-40 overflow-hidden" data-id="element-210">
              <div className="p-2" data-id="element-211">
                <button onClick={() => handleExport('csv-filtered')} className="w-full flex items-center px-3 py-2.5 hover:bg-slate-50 rounded-lg text-sm text-slate-700 group transition-colors" data-id="element-212">
                  <div className="h-8 w-8 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center mr-3 group-hover:bg-emerald-100 transition-colors" data-id="element-213">
                    <FileText className="h-4 w-4" data-id="element-214" />
                  </div>
                  <div className="text-left" data-id="element-215">
                    <p className="font-medium text-navy-900" data-id="element-216">CSV (Filtrados)</p>
                    <p className="text-xs text-slate-500" data-id="element-217">
                      Apenas dados visíveis
                    </p>
                  </div>
                </button>

                <button onClick={() => handleExport('csv-all')} className="w-full flex items-center px-3 py-2.5 hover:bg-slate-50 rounded-lg text-sm text-slate-700 group transition-colors" data-id="element-218">
                  <div className="h-8 w-8 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center mr-3 group-hover:bg-blue-100 transition-colors" data-id="element-219">
                    <FileText className="h-4 w-4" data-id="element-220" />
                  </div>
                  <div className="text-left" data-id="element-221">
                    <p className="font-medium text-navy-900" data-id="element-222">CSV (Completo)</p>
                    <p className="text-xs text-slate-500" data-id="element-223">Todos os produtos</p>
                  </div>
                </button>

                <div className="h-px bg-slate-100 my-1" data-id="element-224" />

                <button onClick={() => handleExport('excel')} className="w-full flex items-center px-3 py-2.5 hover:bg-slate-50 rounded-lg text-sm text-slate-700 group transition-colors" data-id="element-225">
                  <div className="h-8 w-8 rounded-lg bg-green-50 text-green-600 flex items-center justify-center mr-3 group-hover:bg-green-100 transition-colors" data-id="element-226">
                    <FileSpreadsheet className="h-4 w-4" data-id="element-227" />
                  </div>
                  <div className="text-left" data-id="element-228">
                    <p className="font-medium text-navy-900" data-id="element-229">Excel (.xlsx)</p>
                    <p className="text-xs text-slate-500" data-id="element-230">
                      Relatório formatado
                    </p>
                  </div>
                </button>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </div>;
}